import Vue from 'vue';
import App from './App.vue';
import store from "./store";
import axios from 'axios';
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import router from './router'; // Importing the router
import './assets/styles.css'; // Import global styles if any
import VueYoutube from 'vue-youtube'
 
Vue.use(VueYoutube)
window.toastr = require('toastr')
Vue.config.productionTip = false;
Vue.use(VueToastr2);

// axios.defaults.withCredentials = true
axios.defaults.baseURL = 'https://academy.azadicoin.com/api/';

axios.interceptors.request.use(function (config) {
    const token = store.getters.StateUser && store.getters.StateUser.data.access_token;
    config.headers.Authorization =  "Bearer "+token;

    return config;
});
axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    window.toastr.error(error.response.data.message, null, {timeOut: 1000, positionClass: 'toast-bottom-center'});
    if (error.response.status === 401 && router.history.current.name!=='login') {
        store.dispatch('LogOut')
        return router.push('/login');
    }
    else {
      return null;
    }

  }
})

new Vue({
  router,  // Injecting the router into the Vue instance
  store,
  render: h => h(App), // Rendering the root component
}).$mount('#app');
